import React from 'react'
import { Heading, Text, LogoSuite, Testimonial } from '@primer/react-brand'
import Container from './Container'
import SectionHeader from './landing/SectionHeader'
import Eyebrow from './landing/Eyebrow'
import { AUDIENCES, PENDING } from '../landingContent'

// Who it is for, and — once we may show them — who it is already for.
//
// Three placeholders live here behind PENDING flags: member logos, funder
// logos and testimonials. Each renders nothing until its content is real; what
// each needs is listed in docs/civic-lens-landing-page.md. The prospectus names
// the organisations, but a logo on a marketing page is a different permission
// from a name in a funding document.

const MemberLogos = () => {
  if (!PENDING.memberLogos) return null
  return (
    <div style={{ marginTop: '64px' }}>
      <LogoSuite align="start">
        <LogoSuite.Heading visuallyHidden>Member organisations</LogoSuite.Heading>
        <LogoSuite.Description>Paying members include newsrooms, universities, advocacy groups and research teams.</LogoSuite.Description>
        <LogoSuite.Logobar variant="muted">
          {/* <img src=… alt="Organisation name" /> per member, once permission and SVGs are in hand */}
        </LogoSuite.Logobar>
      </LogoSuite>
    </div>
  )
}

const FunderLogos = () => {
  if (!PENDING.funderLogos) return null
  return (
    <div style={{ marginTop: '48px' }}>
      <LogoSuite align="start">
        <LogoSuite.Heading visuallyHidden>Supported by</LogoSuite.Heading>
        <LogoSuite.Description>Supported by Knight, Omidyar, Packard, Reset and Craig Newmark Philanthropies.</LogoSuite.Description>
        <LogoSuite.Logobar variant="muted">
          {/* funder marks */}
        </LogoSuite.Logobar>
      </LogoSuite>
    </div>
  )
}

const Testimonials = () => {
  if (!PENDING.testimonials) return null
  return (
    <div className="two-up-grid" style={{ marginTop: '64px', display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '24px' }}>
      <Testimonial variant="subtle" quoteMarkColor="blue">
        <Testimonial.Quote>{/* real quote */}</Testimonial.Quote>
        <Testimonial.Name position="">{/* name, role, organisation */}</Testimonial.Name>
      </Testimonial>
    </div>
  )
}

const AudienceSection = () => {
  return (
    <section id="who" style={{ padding: '96px 0', background: 'var(--brand-color-canvas-subtle)' }}>
      <Container>
        <SectionHeader
          eyebrow="Who it is for"
          heading="Day-to-day infrastructure for four communities."
          lede="Developed by the Algorithmic Transparency Institute at the National Conference on Citizenship, a congressionally chartered nonprofit, in close collaboration with the people who depend on it. It has supported election monitoring in the United States and internationally, front-page reporting, and large-scale academic research."
        />

        <div
          className="four-up-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
            gap: '24px',
            marginTop: '56px',
          }}
        >
          {AUDIENCES.map(({ key, heading, body }, i) => (
            <div
              key={key}
              style={{
                padding: '24px',
                borderRadius: '12px',
                border: '1px solid var(--brand-color-border-default)',
                background: 'var(--brand-color-canvas-default)',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
              }}
            >
              <Eyebrow tone="muted">{String(i + 1).padStart(2, '0')}</Eyebrow>
              <Heading as="h3" size="6" weight="semibold">{heading}</Heading>
              <Text as="p" size="200" variant="muted" style={{ margin: 0 }}>{body}</Text>
            </div>
          ))}
        </div>

        <MemberLogos />
        <Testimonials />
        <FunderLogos />
      </Container>
    </section>
  )
}

export default AudienceSection
